export enum ChartType {
  BARCHART = 'BARCHART',
  LINECHART = 'LINECHART',
  MONTHS_LEFT_CHART = 'MONTHS_LEFT_CHART',

  // We should probably refactor this two to be a single component
  TODAYS_CASH = 'TODAYS_CASH',
  NET_BURN = 'NET_BURN',
}
